export default __webpack_public_path__ + "static/media/Group_175769.3e6a5ad0.svg";